import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getSelects = store => store[NAME].selects;
export const getBalanceData = store => store[NAME].balanceData;
export const getHasSignedDocument = store => store[NAME].hasSignedDocument;
